<div class="documents">
  <h2>Documents</h2>
  @if (isLoading) {
    <app-skeleton class="documents__skeleton"></app-skeleton>
  } @else {
    <div class="documents__buttons">
      <div matTooltip="You are already at the root folder" [matTooltipDisabled]="!!currentFolder?.folderId">
        <button mat-stroked-button [disabled]="!currentFolder?.folderId" (click)="gotToPreviousFolder()">
          Previous folder
          <mat-icon>drive_file_move_rtl</mat-icon>
        </button>
      </div>
      <button mat-stroked-button (click)="createFolder()" class="documents__buttons--new-folder">
        New folder
        <mat-icon>create_new_folder</mat-icon>
      </button>
      <button mat-stroked-button (click)="uploadFile()">
        Upload document
        <mat-icon>file_upload</mat-icon>
      </button>
    </div>

    <div class="documents__filters">
      <app-filters [companies]="companies" (selectedCustomers)="onCustomersChange($event)"></app-filters>
    </div>
    <app-folder
      class="documents__folder"
      [folder]="currentFolder"
      [pageNumber]="(pageConfig$ | async)?.pageNumber || defaultPageNumber"
      (pageChanged)="onPageChanged($event)"></app-folder>
  }
</div>
